// extracted by mini-css-extract-plugin
export var banner = "culinary-module--banner--5edb2";
export var culinary = "culinary-module--culinary--118cb";
export var fullWidth = "culinary-module--full-width--32e5a";
export var icon = "culinary-module--icon--e3f63";
export var imageContent = "culinary-module--imageContent--844db";
export var img = "culinary-module--img--4dd32";
export var list = "culinary-module--list--bef00";